import teamRequestCardComponent from './teamRequestCard.component';
import teamRequestCardActions from './teamRequestCardActions/teamRequestCardActions';
import teamRequestCardActionsMobile from './teamRequestCardActionsMobile/teamRequestCardActionsMobile';
import teamRequestCardDetails from './teamRequestCardDetails/teamRequestCardDetails';

import teamRequestModalApprove from './teamRequestModalApprove/teamRequestModalApprove';
import teamRequestModalRemove from './teamRequestModalRemove/teamRequestModalRemove';

let teamRequestCardModule = angular.module('vacations-absences.teamRequestCard', [
  teamRequestCardActions,
  teamRequestCardDetails,
  teamRequestModalApprove,
  teamRequestModalRemove,
  teamRequestCardActionsMobile
])

  .component('teamRequestCard', teamRequestCardComponent)

  .name;

export default teamRequestCardModule;



// WEBPACK FOOTER //
// ./client/app/vacations-absences.module/features/teamRequests/teamRequestsList/teamRequestCard/teamRequestCard.js